import { render, staticRenderFns } from "./EditUserRoles.vue?vue&type=template&id=1786af4b&scoped=true&"
import script from "./EditUserRoles.vue?vue&type=script&lang=ts&"
export * from "./EditUserRoles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1786af4b",
  null
  
)

export default component.exports